import { Controller } from 'react-hook-form';
import RichTextEditor from '@molecules/RichTextEditor';

export default function CodeOfConductForm() {
    return (
        <Controller
            name="codeOfConduct"
            render={({ field: { value, onChange /* name, onChange  */ } }) => (
                <RichTextEditor
                    onChange={(_, editor) => {
                        onChange(editor.getData());
                    }}
                    data={value}
                />
            )}
        />
    );
}
